/* @flow weak */

const React = require('react');
const _ = require('lodash');

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');

const PreviewSection = require('./PreviewSection.jsx');
const ConfiguratorSection = require('./ConfiguratorSection.jsx');
const ProductStore = require('../../stores/ProductStore.jsx');
const AnswerStore = require('../../stores/AnswerStore.jsx');
const ValidatorStore = require('../../stores/ValidatorStore.jsx');

const MainSection = React.createClass({
  render() { 
    let classes = _.invert(Config.productline)[ProductStore.getProductLineId()];
    if (classes) classes += (' smi-' + Loader.schoolCode);
    else classes = Loader.schoolCode;

    if (Loader.addConfigToCart && Loader.addConfigToCart == 'true') {
      setTimeout(AnswerStore.triggerAndValidate, 300);
      setTimeout(AnswerStore.onSubmit, 1000);
    }

    return (
    <div id="uc-main-section" className={classes}>
      <PreviewSection />

      <ConfiguratorSection />
    </div>)
  }
});

module.exports = MainSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/MainSection.jsx